import React, { createContext, useContext, useState } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

const LoadingContext = createContext();

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading must be used within a LoadingProvider');
  }
  return context;
};

export const LoadingProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('加载中...');

  const showLoading = (message = '加载中...') => {
    setLoadingMessage(message);
    setLoading(true);
  };

  const hideLoading = () => {
    setLoading(false);
    setLoadingMessage('加载中...');
  };

  const value = {
    loading,
    loadingMessage,
    showLoading,
    hideLoading,
  };

  // 阻止遮罩层下方的所有手势和点击事件
  const stopPropagation = (e) => e.stopPropagation();

  return (
    <LoadingContext.Provider value={value}>
      {children}
      {loading && (
        <div
          // 使用 fixed 铺满全屏，z-index 设为 1000 保证在最上层
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.85)', // 黑色半透明遮罩
            display: 'flex',
            flexDirection: 'column', // 纵向排列：上面动画，下面文字
            alignItems: 'center',
            justifyContent: 'center',
            gap: '16px', // 动画和文字之间的间距
            zIndex: 1000,
          }}
          onClick={stopPropagation}
          onMouseDown={stopPropagation}
          onMouseUp={stopPropagation}
          onTouchStart={stopPropagation}
          onTouchEnd={stopPropagation}
          onKeyDown={stopPropagation}
        >
          {/* 上边：直接渲染加载动画 */}
          <Spin indicator={<LoadingOutlined style={{ fontSize: 48}} spin />} />
          
          {/* 下边：渲染文本字体 */}
          {loadingMessage && (
            <p style={{ color: 'rgba(255, 255, 255, 0.85)', margin: 0, fontSize: '14px', trackingWider: '0.05em' }}>
              {loadingMessage}
            </p>
          )}
        </div>
      )}
    </LoadingContext.Provider>
  );
};